import { render, staticRenderFns } from "./TrainingRequestCatalogPage.vue?vue&type=template&id=569054c3&"
import script from "./TrainingRequestCatalogPage.vue?vue&type=script&lang=js&"
export * from "./TrainingRequestCatalogPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports